import { TableCell, Button, Icon } from '@safedns/skydns-ui-react-lib';

import { actionTableCellStyle } from '../../styles/tableStyles';

import sprite from '../../icons/sprite.svg';

const TableRowButtons = ({
  isEditable,
  isPDC,
  isSaveDisabled = false,
  onSave,
  onToggleRemoveModal,
  switchToEditMode,
  declineEditMode,
}) => {
  if (isEditable) {
    return (
      <>
        <TableCell sx={actionTableCellStyle}>
          <Button
            onClick={onSave}
            variant="icon"
            isIconButton
            disabled={isSaveDisabled}
          >
            {isSaveDisabled ? (
              <Icon id="save-disabled" sprite={sprite} width={24} height={24} />
            ) : (
              <Icon id="save" sprite={sprite} width={24} height={24} />
            )}
          </Button>
        </TableCell>
        <TableCell sx={actionTableCellStyle}>
          <Button variant="icon" isIconButton onClick={declineEditMode}>
            <Icon id="decline" sprite={sprite} width={24} height={24} />
          </Button>
        </TableCell>
      </>
    );
  }

  return (
    <>
      <TableCell sx={actionTableCellStyle}>
        <Button variant="icon" isIconButton onClick={switchToEditMode}>
          <Icon id="edit" sprite={sprite} width={24} height={24} />
        </Button>
      </TableCell>
      <TableCell sx={actionTableCellStyle}>
        {isPDC ? null : (
          <Button variant="icon" isIconButton onClick={onToggleRemoveModal}>
            <Icon id="remove" sprite={sprite} width={24} height={24} />
          </Button>
        )}
      </TableCell>
    </>
  );
};

export default TableRowButtons;
